import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stripe-s': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M155.3 154.6c0 64.2 218 33.7 218 203.9 0 102.6-81.7 153.6-200.3 153.6-44.9-0.1-114.8-14.6-156-32.4v-128.5c47.9 26 108.9 45.5 156.1 45.5 31.8 0 54.7-8.5 54.7-34.9 0-68.1-216.8-42.5-216.8-200.4 0-101 77.1-161.4 192.8-161.4 47.3 0 94.5 7.2 141.8 26.1v134.3c-43.4-23.4-98.5-36.7-141.9-36.7-29.8 0-48.4 8.6-48.4 30.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stripe-s.js
// module id = 1040
// module chunks = 0